import Api from "~/service/Api";

class TourYouTubeVideoRepository {
  delete(tourId) {
    return Api.delete(`/tour/you-tube-videos/${tourId}`);
  }
}

export default TourYouTubeVideoRepository;
